<template>
  <div class="d-flex body-2 ml-1">
    <div v-if="beginningDate">
      {{ `Ngày khai giảng: ${moment(beginningDate).format('DD-MM-YYYY')}` }}
    </div>
    <div v-else class="d-flex ml-1">
      <div>{{ 'Ngày khai giảng:' }}</div>
      <div class="d-flex text-error ml-1">
        <div>
          {{ 'Chưa cấu hình ngày khai giảng,' }}
        </div>
        <div class="link-text" @click="$emit('redirect')">
          {{ `thiết lập` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    beginningDate: {
      type: [String, Date],
      default: null,
    },
  },
  data() {
    return {
      moment,
    }
  },
}
</script>

<style lang="scss" scoped>
.text-error {
  font-size: 13px;
  color: red;
  font-style: italic;
}
.link-text {
  margin-left: 4px;
  color: rgb(74, 74, 255);
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
